// Utils
import {matchUrlInRouteConfigs} from '../../../universal/core/route/routeUtils'

function getCombinedVariantText(activeVariant) {
  if (!activeVariant) {
    return ''
  }

  return Object.values(activeVariant?.values).join(' / ')
}

function generateVariantState({variants, variantDisplayTypes}) {
  if (!variants || !variants.length) {
    return {variants: null, activeVariant: null}
  }

  let activeVariant = {
    values: {},
    hasCombination: true,
  }

  const generatedVariants = variants?.reduce((collectedVariants, variantGroup) => {
    const properties = variantGroup?.properties
    const currentDisplayType = variantDisplayTypes.find((type) => type.name === variantGroup.name)

    if (!collectedVariants[variantGroup?.name]) {
      collectedVariants[variantGroup?.name] = {
        name: variantGroup?.name,
        variantType: currentDisplayType?.variantType,
        variantShape: currentDisplayType?.variantShape,
        isShowPrice: variantGroup?.isShowPrice,
        properties: {}
      }
    }

    collectedVariants[variantGroup?.name].properties = properties.map((variant) => {
      if (variant.isSelected) {
        activeVariant = {
          ...activeVariant,
          values: {
            ...activeVariant.values,
            [variantGroup?.name]: variant.name,
          },
          sku: variant.sku,
          urlName: variant.urlName,
          variantCount: variants?.length,
        }
      }

      return {
        sku: variant.sku,
        urlName: variant.urlName,
        name: variantGroup.name,
        value: variant.name,
        isSelected: variant.isSelected,
        isInStock: variant.isInStock,
        isPreOrder: variant.isPreOrder,
        thumbnail: variant?.thumbnailInformation,
        price: variant.price,
      }
    }) || []

    return collectedVariants
  }, {})

  return {variants: generatedVariants, activeVariant}
}

function getAvailableVariants({combinedVariants}) {
  if (!combinedVariants?.length) {
    return []
  }

  const availableVariants = combinedVariants.reduce((acc, currentVariantGroup) => {
    let variantAvailabilities = {}

    currentVariantGroup.forEach((variant) => {
      const {name, value, sku, urlName} = variant

      variantAvailabilities[name] = value
      variantAvailabilities.sku = sku
      variantAvailabilities.urlName = null

      if (variantAvailabilities.sku && !variantAvailabilities.urlName) {
        variantAvailabilities.urlName = urlName
      }
    })

    acc.push(variantAvailabilities)

    return acc
  }, []);

  return availableVariants
}

function getUnAvailableVariants(availableVariants) {
  return availableVariants?.filter(variant => variant?.sku === null)
}

export {
  getCombinedVariantText,
  generateVariantState,
  getUnAvailableVariants,
  getAvailableVariants,
}
